import { render, staticRenderFns } from "./MemberDetailKycComponent.vue?vue&type=template&id=43aa39fc&"
import script from "./MemberDetailKycComponent.vue?vue&type=script&lang=js&"
export * from "./MemberDetailKycComponent.vue?vue&type=script&lang=js&"
import style0 from "./MemberDetailKycComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports